
import React, { useState } from 'react';

function WhyChooseUsSection() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    date: '',
    pickupLocation: '',
    dropLocation: '',
    services: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('Form submitted:', formData);
  };

  return (
    <div className="why-choose-us dark-section">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="why-choose-box">
              <div className="why-choose-content">
                <div className="section-title">
                  <h3 className="wow fadeInUp">why choose us</h3>
                  <h2 className="text-anime-style-2" data-cursor="-opaque">Why we're the preferred choice <span>for moving</span></h2>
                </div>

                <div className="why-choose-body wow fadeInUp" data-wow-delay="0.2s">
                  <ul>
                    <li>Customer First - Your satisfaction is our priority.</li>
                    <li>Timely service with no hidden fees.</li>
                    <li>Safe, secure transport for your belongings.</li>
                    <li>Customized moving plans to fit your needs.</li>
                    <li>Eco-Friendly Approach, by optimizing routes and reducing empty trips.</li>
                  </ul>
                </div>
              </div>

              <div className="request-quote-form-box wow fadeInUp" data-wow-delay="0.4s">
                <h3>request a quote</h3>

                <div className="request-quote-form">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="form-group col-md-6 mb-4">
                        <input 
                          type="text" 
                          name="name" 
                          className="form-control" 
                          placeholder="name" 
                          value={formData.name}
                          onChange={handleChange}
                          required 
                        />
                      </div>

                      <div className="form-group col-md-6 mb-4">
                        <input 
                          type="email" 
                          name="email" 
                          className="form-control" 
                          placeholder="Email" 
                          value={formData.email}
                          onChange={handleChange}
                          required 
                        />
                      </div>

                      <div className="form-group col-md-6 mb-4">
                        <input 
                          type="text" 
                          name="phone" 
                          className="form-control" 
                          placeholder="Phone" 
                          value={formData.phone}
                          onChange={handleChange}
                          required 
                        />
                      </div>

                      <div className="form-group col-md-6 mb-4">
                        <input 
                          type="date" 
                          name="date" 
                          className="form-control" 
                          value={formData.date}
                          onChange={handleChange}
                          required 
                        />
                      </div>

                      <div className="form-group col-md-6 mb-4">
                        <input 
                          type="text" 
                          name="pickupLocation" 
                          className="form-control" 
                          placeholder="Pickup location" 
                          value={formData.pickupLocation}
                          onChange={handleChange}
                          required 
                        />
                      </div>

                      <div className="form-group col-md-6 mb-4">
                        <input 
                          type="text" 
                          name="dropLocation" 
                          className="form-control" 
                          placeholder="Drop location" 
                          value={formData.dropLocation}
                          onChange={handleChange}
                          required 
                        />
                      </div>

                      <div className="form-group col-md-12 mb-4">
                        <select 
                          name="services" 
                          className="form-control form-select" 
                          value={formData.services}
                          onChange={handleChange}
                          required
                        >
                          <option value="" disabled>service type</option>
                          <option value="residential_moving">Residential Moving</option>
                          <option value="commercial_moving">Commercial Moving</option>
                          <option value="specialty_item">Specialty Item Moving</option>
                          <option value="eco_friendly">Eco-Friendly Moving</option>
                          <option value="office_relocation">Office Relocation</option>
                          <option value="packing_unpacking">Packing & Unpacking</option>
                          <option value="storage_solutions">Storage Solutions</option>
                          <option value="moving_assistance">Moving Assistance</option>
                        </select>
                      </div>

                      <div className="form-group col-md-12">
                        <button type="submit" className="btn-default">contact us now</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default WhyChooseUsSection;
